<div style="width: auto">
  <div
    class="card mt-5 align-items-center"
    style="background-color: lightgray"
    *appIsGranted="['INFO', 'INFO_GATEWAYS', 'READ']"
  >
    <div class="d-flex">
      <h4 class="text-align-center"><b>Gateways</b></h4>
      <!-- <countdown
        #countDownGateways
        style="color: gray"
        [config]="{ leftTime: timeToRefreash, format: 'ss' }"
      ></countdown>
      <span style="color: gray">s</span> -->
    </div>
    <div class="row d-flex justify-content-between">
      <div class="col">
        <div class="card" style="width: 22rem">
          <div class="card-body">
            <ng-container *ngFor="let item of gateways">
              <div
                class="card mb-2"
                [ngStyle]="{
                  'box-shadow':
                    item.iconStatus == 'ok'
                      ? '0 2px 3px green'
                      : item.iconStatus == 'error'
                      ? '0 2px 3px red'
                      : '0 2px 3px yellow'
                }"
              >
                <div class="d-inline">
                  <ng-container *ngIf="item.iconStatus == 'ok'">
                    <i class="uil uil-circle" style="color: green"></i>
                  </ng-container>
                  <ng-container *ngIf="item.iconStatus == 'warning'">
                    <i class="uil uil-circle" style="color: orange"></i>
                  </ng-container>
                  <ng-container *ngIf="item.iconStatus == 'error'">
                    <i class="uil uil-exclamation" style="color: red"></i>
                  </ng-container>
                  <b>{{ item.devices }} | </b>
                  <b>
                    <span class="text-button" (click)="openURLGateway(item.ip)">
                      {{ item.ip }}
                    </span>
                    -{{ item.datahora }}</b
                  >
                </div>
              </div>
            </ng-container>
          </div>
          <div
            class="card-footer"
            [ngStyle]="{ 'background-color': gatewayStatus }"
          ></div>
        </div>
      </div>
    </div>
  </div>
  <ng-container *ngIf="isProd">
    <div *appIsGranted="['INFO', 'INFO_RDASHBOARD', 'READ']">
      <iframe id="rdash" [src]="urlRdash" width="100%" height="800px"></iframe>
    </div>
  </ng-container>

  <div class="card">
    <div class="card-body">
      <!-- Nav tabs -->

      <ul
        ngbNav
        #customNav="ngbNav"
        [activeId]="4"
        class="nav nav-tabs nav-tabs-custom"
        (navChange)="tabChange($event)"
      >
        <li [ngbNavItem]="1" *appIsGranted="['INFO', 'INFO_GATEWAYS', 'READ']">
          <a ngbNavLink>
            <span class="d-block d-sm-none"
              ><i class="fas fa-building"></i
            ></span>
            <span class="d-none d-sm-block"
              >Geral
              <!-- <i class="uil-exclamation-circle" style="color: red"></i> -->
            </span>
          </a>

          <ng-template ngbNavContent>
            <ng-template [ngTemplateOutlet]="TabgGeneral"></ng-template>
            <!-- <ng-template [ngTemplateOutlet]="TabManut"></ng-template> -->
          </ng-template>
        </li>
        <li [ngbNavItem]="2" *appIsGranted="['INFO', 'INFO_GATEWAYS', 'READ']">
          <a ngbNavLink>
            <span class="d-block d-sm-none"
              ><i class="fa fa-battery-half" aria-hidden="true"></i
            ></span>
            <span class="d-none d-sm-block"
              >A40B
              <!-- <i class="uil-exclamation-circle" style="color: red"></i> -->
            </span>
          </a>
          <ng-template ngbNavContent>
            <ng-template [ngTemplateOutlet]="TabA40B"></ng-template>
            <!-- <ng-template [ngTemplateOutlet]="TabManut"></ng-template> -->
          </ng-template>
        </li>

        <!-- <li [ngbNavItem]="3">
            <a ngbNavLink>
              <span class="d-block d-sm-none"
                ><i class="fa fa-book" aria-hidden="true"></i
              ></span>
              <span class="d-none d-sm-block">Notícias</span>
            </a>
            <ng-template ngbNavContent>
              <ng-template [ngTemplateOutlet]="TabNewsletter"></ng-template>
            </ng-template>
          </li> -->
        <li [ngbNavItem]="4" *appIsGranted="['INFO', 'INFO_MEGA', 'READ']">
          <a ngbNavLink>
            <span class="d-block d-sm-none"><i class="fas fa-tree"></i></span>
            <span class="d-none d-sm-block">Mega</span>
          </a>
          <ng-template ngbNavContent>
            <ng-template [ngTemplateOutlet]="TabMEGA"></ng-template>
          </ng-template>
        </li>

        <li
          [ngbNavItem]="5"
          *appIsGranted="['INFO', 'INFO_INSTALLATION_PHOTOS', 'READ']"
        >
          <a ngbNavLink>
            <span class="d-block d-sm-none"><i class="mdi-camera"></i></span>
            <span class="d-none d-sm-block">Fotos Instalações</span>
          </a>
          <ng-template ngbNavContent>
            <ng-template
              [ngTemplateOutlet]="TabInstallationPhotos"
            ></ng-template>
          </ng-template>
        </li>

        <li
          [ngbNavItem]="6"
          *appIsGranted="['INFO', 'INFO_PROCESS_AUTO', 'READ']"
        >
          <a ngbNavLink>
            <span class="d-block d-sm-none"><i class="mdi-dolly"></i></span>
            <span class="d-none d-sm-block">Process Auto Logan </span>
          </a>
          <ng-template ngbNavContent>
            <ng-template [ngTemplateOutlet]="TabProcessAuto"></ng-template>
          </ng-template>
        </li>

          <li
          [ngbNavItem]="7"
          *appIsGranted="['INFO', 'INFO_PROCESS_AUTO', 'READ']"
        >
          <a ngbNavLink>
            <span class="d-block d-sm-none"><i class="mdi-dolly"></i></span>
            <span class="d-none d-sm-block">Worker Auto Commands </span>
          </a>
          <ng-template ngbNavContent>
            <div style="overflow: auto;">
              <ng-template [ngTemplateOutlet]="AutoWorkerCommands"></ng-template> 
              <hr> <!-- linha separadora -->
              <ng-template [ngTemplateOutlet]="AutoWorkerCommandsAuto"></ng-template> 
              <hr> <!-- linha separadora --> 
              <ng-template [ngTemplateOutlet]="AutoWorkerCommandsMEGA"></ng-template> 
            </div>
          </ng-template>
        </li>
      </ul>

      <!-- Tab panes -->
      <div class="tab-content p-3 text-muted">
        <div [ngbNavOutlet]="customNav"></div>
      </div>
    </div>
  </div>

  <ng-template #AutoWorkerCommands>  
    <h3 style="text-align: left; width: 100%; margin-bottom: 20px;">
        Worker Auto - Status Reenvio de Comandos
      </h3> 
    <div style="display: flex; align-items: flex-start; gap: 20px;"> 
      <div style="display: block; width: 400px; height: 400px;">
        <canvas baseChart
                [data]="pieChartData"
                [type]="pieChartType"
                [options]="pieChartOptions"
                [plugins]="pieChartPlugins">
          </canvas>     
      </div>
      <div style="flex: 1;">
        <table class="table table-fit table-bordered table-hover">
          <thead class="table-primary">
            <tr>
              <th>Serial</th>
              <th>Mensagem</th>
              <th>Sistema</th>
              <th>Comando</th>
              <th>Valor</th>
              <th>Data Requisição</th>
              <th>Status</th>
            </tr>
          </thead>
            <tbody>
              <tr *ngFor="let cmd of comandos | paginate: { itemsPerPage: 10, currentPage: ComandosPaginaAtual }">
                  <td>{{ cmd.serial }}</td>
                  <td>{{ cmd.mensagem }}</td>
                  <td>{{ cmd.sistema }}</td>
                  <td>{{ cmd.comando }}</td>
                  <td>{{ cmd.param }}</td>
                  <td>{{ cmd.requestDate }}</td>
                  <td>{{ cmd.statusComando }}</td>
                </tr>
              </tbody>   
        </table>
        <!-- Controles de Paginação -->
        <div>
          <button (click)="paginaAnterior()" class="btn btn-primary"  [disabled]="ComandosPaginaAtual === 1">Anterior</button>
          <span>Página {{ ComandosPaginaAtual }} de {{ totalPaginas }}</span>
          <button (click)="proximaPagina()" class="btn btn-primary" [disabled]="ComandosPaginaAtual === totalPaginas">Próxima</button>
        </div>
        <p>
          Total: {{ comandos.length }}
        </p> 
          <div *ngIf="comandos.length > 0">
            <button 
              (click)="exportToCSV(comandos, 'worker-auto_status_reenvio')" 
              class="btn btn-success rounded">
              Exportar CSV
            </button>
          </div>  
      </div>
    </div>
  </ng-template>

  <ng-template #AutoWorkerCommandsAuto>
    <h3 style="text-align: left; width: 100%; margin-bottom: 20px;">
        Worker Auto - Status Comandos
      </h3> 
    <div style="display: flex; align-items: flex-start; gap: 20px;"> 
          <div style="display: block; width: 400px; height: 400px;">
            <canvas baseChart
                  [data]="pieChartDataAuto"
                  [type]="pieChartTypeAuto"
                  [options]="pieChartOptionsAuto"
                  [plugins]="pieChartPluginsAuto">
            </canvas>
        </div>
        <div style="flex: 1;">
          <table class="table table-fit table-bordered table-hover">
            <thead class="table-primary">
              <tr>
                <th>Serial</th>
                <th>Sistema</th>
                <th>Comando</th>
                <th>Valor</th>
                <th>Data Requisição</th>
                <th>Status</th>
              </tr>
            </thead>
              <tbody>
                <tr *ngFor="let cmd of comandoStatus | paginate: { itemsPerPage: 10, currentPage: ComandosPaginaAtualAuto }">
                    <td>{{ cmd.serial }}</td>
                    <td>{{ cmd.sistema }}</td>
                    <td>{{ cmd.comando }}</td>
                    <td>{{ cmd.param }}</td>
                    <td>{{ cmd.requestDate }}</td>
                    <td>{{ cmd.statusComando }}</td>
                  </tr>
                </tbody>   
          </table>
          <!-- Controles de Paginação -->
          <div>
            <button (click)="paginaAnteriorAuto()" class="btn btn-primary" [disabled]="ComandosPaginaAtualAuto === 1">Anterior</button>
            <span>Página {{ ComandosPaginaAtualAuto }} de {{ totalPaginasAuto }}</span>
            <button (click)="proximaPaginaAuto()" class="btn btn-primary" [disabled]="ComandosPaginaAtualAuto === totalPaginasAuto">Próxima</button>
          </div>
          <p>
            Total: {{ comandoStatus.length }}
          </p>  
          <div *ngIf="comandoStatus.length > 0">
            <button 
              (click)="exportToCSV(comandoStatus, 'worker-auto_status_comandos')" 
              class="btn btn-success rounded">
              Exportar CSV
            </button>
          </div> 
      </div>
    </div>
  </ng-template>

   <ng-template #AutoWorkerCommandsMEGA>
    <h3 style="text-align: left; width: 100%; margin-bottom: 20px;">
        MEGA - Comandos Expirados e Comandos com Erro
      </h3> 
    <div style="display: flex; align-items: flex-start; gap: 20px;"> 
          <div style="display: block; width: 400px; height: 400px;">
            <canvas baseChart
                  [data]="pieChartDataMEGA"
                  [type]="pieChartTypeMEGA"
                  [options]="pieChartOptionsMEGA"
                  [plugins]="pieChartPluginsMEGA">
            </canvas>
        </div>
        <div style="flex: 1;">
          <table class="table table-fit table-bordered table-hover">
            <thead class="table-primary">
              <tr>
                <th>Serial</th>
                <th>Sistema</th>
                <th>Comando</th>
                <th>Valor</th>
                <th>Data Requisição</th>
                <th>Status</th>
              </tr>
            </thead>
              <tbody>
                <tr *ngFor="let cmd of comandoMega | paginate: { itemsPerPage: 10, currentPage: ComandosPaginaAtualMEGA }">
                    <td>{{ cmd.serial }}</td>
                    <td>{{ cmd.sistema }}</td>
                    <td>{{ cmd.comando }}</td>
                    <td>{{ cmd.param }}</td>
                    <td>{{ cmd.requestDate }}</td>
                    <td>{{ cmd.statusComando }}</td>
                  </tr>
                </tbody>   
          </table>
          <!-- Controles de Paginação -->
          <div>
            <button (click)="paginaAnteriorMEGA()" class="btn btn-primary" [disabled]="ComandosPaginaAtualMEGA === 1">Anterior</button>
            <span>Página {{ ComandosPaginaAtualMEGA }} de {{ totalPaginasMEGA }}</span>
            <button (click)="proximaPaginaMEGA()" class="btn btn-primary" [disabled]="ComandosPaginaAtualMEGA === totalPaginasMEGA">Próxima</button>
          </div>
          <p>
            Total: {{ comandoMega.length }}
          </p>
          <div *ngIf="comandoMega.length > 0">
            <button 
              (click)="exportToCSV(comandoMega, 'comandos_mega_erro_expirado')" 
              class="btn btn-success rounded">
              Exportar CSV
            </button>
          </div>
      </div>
    </div>
  </ng-template>

  <ng-template #TabProcessAuto>
    <div class="card align-items-center">
      <b>{{ logProcessInternal }}</b>
    </div>
    <div class="card align-items-center">
      <ng-container
        *ngIf="
          logProcessAutoInfo == undefined || logProcessAutoInfo.length == 0
        "
      >
        <b>Aguardando informações</b></ng-container
      >
    </div>
    <div style="display: flex; float: none; margin: 0 auto; flex-wrap: wrap">
      <ng-container
        *ngIf="
          logProcessAutoInfo != undefined && logProcessAutoInfo?.info.length > 0
        "
      >
        <ng-container
          *ngFor="let item of logProcessAutoInfo?.info; let i = index"
        >
          <div class="ms-2">
            <table
              class="table table-fit table-bordered table-hover"
              style="max-inline-size: fit-content"
            >
              <thead class="table-primary">
                <tr>
                  <th class="text-center" scope="col" colspan="2">
                    {{ item.group }} - {{ item.status }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td scope="col" colspan="2">
                    <div class="flex-grow-1">
                      <span class="float-end fw-medium"
                        >{{ returnLogProgress(item, i) }}%</span
                      >
                      <div class="progress animated-progess custom-progress">
                        <div
                          [id]="'progress-bar-process' + i"
                          class="progress-bar"
                          role="progressbar"
                          aria-valuemin="0"
                          aria-valuemax="100"
                        ></div>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td class="text-center" scope="col">Quantidade de etapas</td>
                  <td>{{ item.infoItemSteps.length }}</td>
                </tr>
                <tr>
                  <td class="text-center" scope="col">Total de dispositivos</td>
                  <td>{{ item.total }}</td>
                </tr>
                <tr>
                  <td class="text-center" scope="col">
                    Dispositivos sem posição nos últimos 7 dias
                  </td>
                  <td>{{ item.lastPositionMoreThanSevenDays }}</td>
                </tr>
                <tr>
                  <td class="text-center" scope="row" colspan="2">
                    <table class="table table-fit">
                      <thead class="table-primary">
                        <th class="text-center" scope="col">
                          Quantidade de seriais por status da etapa
                        </th>
                      </thead>
                      <tbody>
                        <ng-container
                          *ngFor="
                            let status of item.states;
                            let indexState = index
                          "
                        >
                          <tr>
                            <td class="text-center" scope="row">
                              {{ status }}
                            </td>
                            <td class="text-center" scope="row">
                              {{ item.statesQtd[indexState] }}
                            </td>
                          </tr>
                        </ng-container>
                      </tbody>
                    </table>
                  </td>
                </tr>
                <tr>
                  <td class="text-center" scope="row" colspan="2">
                    <table class="table table-fit">
                      <thead class="table-primary">
                        <th class="text-center" scope="col">
                          Quantidade de seriais em cada etapa
                        </th>
                      </thead>
                      <tbody>
                        <ng-container
                          *ngFor="
                            let infoItemStep of item.infoItemSteps;
                            let indexStep = index
                          "
                        >
                          <tr>
                            <td class="text-center" scope="row">
                              {{
                                item.infoItemSteps.length - 1 == indexStep
                                  ? "CONCLUIDO"
                                  : "Etapa " + (indexStep + 1)
                              }}
                            </td>
                            <td class="text-center" scope="row">
                              {{ infoItemStep }}
                            </td>
                          </tr>
                        </ng-container>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </ng-container>
      </ng-container>
    </div>
    <div class="row d-flex">
      <div class="col-md">
        <button class="btn btn-sm btn-primary" (click)="logPause()">
          Pausar Log
        </button>
      </div>
      <div class="col-md">
        <div class="form-group">
          <label>Filtro</label>
          <input
            class="input"
            type="text"
            [(ngModel)]="logProcessAutoFilter"
            (ngModelChange)="filterLogProcess()"
          />
        </div>
      </div>
      <div class="col-md">
        <div class="form-group">
          <label>Qtd Linhas</label>
          <input
            class="input"
            type="number"
            [(ngModel)]="logProcessAutoLimit"
          />
        </div>
      </div>
    </div>
    <div class="card">
      <textarea
        #textareaLog
        class="input w-100"
        [scrollTop]="textareaLog.scrollHeight"
        >{{ logProcessAutoText }}</textarea
      >
    </div>
    <div>
      <input
        class="input w-100"
        [(ngModel)]="logProcessAuto[logProcessAuto.length - 1]"
      />
    </div>
  </ng-template>

  <!-- Tab General-->
  <ng-template #TabgGeneral>
    <div
      class="card mt-2 d-flex flex-wrap align-content-center"
      style="background-color: lightgray"
    >
      <ng-container *ngIf="baseHealth != undefined">
        <div class="card" style="align-items: center">
          <div>
            <label>Quantidade de dias</label>
            <input
              type="number"
              [(ngModel)]="chartLineGSMAmountItems[0]"
              (change)="mounthGraphBaseHealthGSM()"
            />
          </div>
          <h3 class="text-align-center">
            {{ baseHealth.data }}
            {{ baseHealth.total_devices_installed }} dispositivos instalados em
            {{ baseHealth.total_vehicles_installed }} veículos
            <i
              class="fa fa-info-circle"
              aria-hidden="true"
              data-placement="bottom"
              ngbTooltip="Faz um compilado de todas as posições no dia (d-1) e gera os dados abaixo. É necessário que tenha chegado as posições no dia que o script rodou."
            ></i>
          </h3>
        </div>
        <div class="card m-2">
          <div class="row d-flex" style="inline-size: -webkit-fill-available">
            <div class="w-100">
              <i
                class="fa fa-info-circle ms-5"
                aria-hidden="true"
                data-placement="left"
                ngbTooltip="Filtro considerando dispositivos GSM"
              ></i>
              <canvas
                baseChart
                [options]="chartGSMPosition.options"
                [datasets]="chartGSMPosition.data.datasets"
                [labels]="chartGSMPosition.data.labels"
              >
              </canvas>
            </div>
          </div>
          <div></div>
          <ngb-accordion #acc="ngbAccordion">
            <ngb-panel id="static-1">
              <ng-template ngbPanelTitle class="accordion-header">
                <h2 class="accordion-header" id="gen-ques-headingOne">
                  <button
                    class="accordion-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#gen-ques-collapseOne"
                    aria-expanded="false"
                    aria-controls="gen-ques-collapseOne"
                  >
                    Status dos dispositivos GSM
                  </button>
                </h2>
              </ng-template>
              <ng-template ngbPanelContent>
                <table class="table table-fit table-bordered table-hover">
                  <thead class="table-primary">
                    <tr>
                      <th class="text-center" scope="col" colspan="6">
                        <i
                          class="fa fa-arrow-circle-left"
                          aria-hidden="true"
                          style="cursor: pointer"
                          (click)="changeIndexGSMTable(-1)"
                        ></i>
                        Status dos dispositivos GSM x Dias sem posição-
                        {{
                          getValuesList(
                            baseHealth.charts.GSMHistrogramPosition[
                              baseHealthGSMTableIndex
                            ],
                            "date"
                          )
                        }}
                        <i
                          class="fa fa-arrow-circle-right"
                          aria-hidden="true"
                          style="cursor: pointer"
                          (click)="changeIndexGSMTable(+1)"
                        ></i>
                      </th>
                    </tr>
                    <tr>
                      <th class="text-center" scope="col">Status</th>
                      <th
                        class="text-center"
                        scope="col"
                        *ngFor="
                          let key of getKeysSub(
                            baseHealth.charts.GSMHistrogramPosition[
                              baseHealthGSMTableIndex
                            ],
                            ['date', 'totalDevices', 'totalStatus', 'items']
                          )
                        "
                      >
                        <ng-container *ngIf="key == 'withoutPosition'">
                          Sem posição
                        </ng-container>
                        <ng-container *ngIf="key == 'betweenOneAndFour'">
                          0 a 3 dias
                        </ng-container>
                        <ng-container *ngIf="key == 'betweenFourAndFifteen'">
                          4 a 15 dias
                        </ng-container>
                        <ng-container *ngIf="key == 'greaterThenFifteen'">
                          > 15 dias
                        </ng-container>

                        <ng-container
                          *ngIf="
                            hasKey(
                              getValuesList(
                                baseHealth.charts.GSMHistrogramPosition[
                                  baseHealthGSMTableIndex
                                ],
                                key
                              ),

                              'items'
                            )
                          "
                        >
                          <i
                            class="fa fa-copy ms-2"
                            aria-hidden="true"
                            style="cursor: pointer"
                            ngbTooltip="Copiar para área de transferencia os seriais"
                            (click)="
                              copyToClipboardSimple(
                                getValuesList(
                                  getValuesList(
                                    baseHealth.charts.GSMHistrogramPosition[
                                      baseHealthGSMTableIndex
                                    ],
                                    key
                                  ),
                                  'items'
                                )
                              )
                            "
                          ></i>
                        </ng-container>
                      </th>
                      <th class="text-center" scope="col">Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      *ngFor="
                        let key of getKeys(
                          baseHealth.charts.GSMHistrogramPosition[
                            baseHealthGSMTableIndex
                          ].totalStatus
                        )
                      "
                    >
                      <td class="text-center" scope="row">{{ key }}</td>
                      <ng-container
                        *ngFor="
                          let subKey of getKeysSub(
                            baseHealth.charts.GSMHistrogramPosition[
                              baseHealthGSMTableIndex
                            ],
                            ['date', 'totalDevices', 'totalStatus', 'items']
                          )
                        "
                      >
                        <td class="text-center" scope="row">
                          {{
                            getValuesList(
                              getValuesList(
                                baseHealth.charts.GSMHistrogramPosition[
                                  baseHealthGSMTableIndex
                                ],
                                subKey
                              ),
                              key
                            )
                          }}
                        </td></ng-container
                      >
                      <td class="text-center" scope="row">
                        <b>
                          {{
                            getValuesList(
                              getValuesList(
                                baseHealth.charts.GSMHistrogramPosition[
                                  baseHealthGSMTableIndex
                                ],
                                "totalStatus"
                              ),
                              key
                            )
                          }}</b
                        >
                      </td>
                    </tr>

                    <tr>
                      <td class="text-center" scope="col"><b>Total</b></td>
                      <ng-container
                        *ngFor="
                          let key of getKeysSub(
                            baseHealth.charts.GSMHistrogramPosition[
                              baseHealthGSMTableIndex
                            ],
                            ['date', 'totalDevices', 'totalStatus', 'items']
                          )
                        "
                      >
                        <td class="text-center" scope="col">
                          <b>{{
                            getValuesList(
                              baseHealth.charts.GSMHistrogramPosition[
                                baseHealthGSMTableIndex
                              ],
                              key
                            ).qtd
                          }}</b>
                        </td>
                      </ng-container>
                      <td class="text-center" scope="col">
                        <b>{{
                          getValuesList(
                            baseHealth.charts.GSMHistrogramPosition[
                              baseHealthGSMTableIndex
                            ],
                            "totalDevices"
                          )
                        }}</b>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </ng-template>
            </ngb-panel>
          </ngb-accordion>
        </div>

        <div class="row d-flex" style="inline-size: -webkit-fill-available">
          <ng-container *ngIf="baseHealth.batteryInternalA40B != undefined">
            <div class="col">
              <div
                class="card m-2 align-items-center"
                style="width: max-content"
              >
                <div class="card-body">
                  <div class="ms-2" style="text-align: end">
                    <i
                      class="fa fa-copy"
                      style="cursor: pointer"
                      (click)="copyToClipboard(baseHealth.batteryInternalA40B)"
                      ngbTooltip="Copiar para área de transferência"
                      aria-hidden="true"
                    ></i>
                  </div>
                  <div style="text-align: center">
                    <i
                      class="fa fa-info-circle"
                      aria-hidden="true"
                      ngbTooltip="Valores de tensão mínima e máxima do dia. Lembrando que é apenas dos dispositivos que enviaram posição no dia analisado. (existe um limite de amostras para apresentar aqui, não são todos)"
                    ></i>
                  </div>

                  <table class="table table-fit table-bordered table-hover">
                    <thead class="table-primary">
                      <tr>
                        <th class="text-center" scope="col" colspan="4">
                          Bateria interna A40B
                        </th>
                      </tr>
                      <tr>
                        <th class="text-center" scope="col">Serial</th>
                        <th class="text-center" scope="col">Min</th>
                        <th class="text-center" scope="col">Max</th>
                        <th class="text-center" scope="col">Dias instalado</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        *ngFor="
                          let item of baseHealth.batteryInternalA40B.seriais
                            | paginate
                              : {
                                  itemsPerPage: 5,
                                  currentPage:
                                    baseHealth.batteryInternalA40B.currentPage,
                                  id: 'batteryInternalA40B'
                                };
                          let i = index
                        "
                      >
                        <td class="text-center" scope="row">{{ item }}</td>
                        <td class="" scope="row">
                          {{
                            baseHealth.batteryInternalA40B.min[
                              getIndex(
                                baseHealth.batteryInternalA40B.seriais,
                                item
                              )
                            ]
                          }}
                        </td>
                        <td class="" scope="row">
                          {{
                            baseHealth.batteryInternalA40B.max[
                              getIndex(
                                baseHealth.batteryInternalA40B.seriais,
                                item
                              )
                            ]
                          }}
                        </td>
                        <td class="" scope="row">
                          {{
                            baseHealth.batteryInternalA40B.diasInstalado[
                              getIndex(
                                baseHealth.batteryInternalA40B.seriais,
                                item
                              )
                            ]
                          }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <pagination-controls
                  [autoHide]="true"
                  [maxSize]="5"
                  id="batteryInternalA40B"
                  (pageChange)="
                    baseHealth.batteryInternalA40B.currentPage = $event
                  "
                  nextLabel=""
                  previousLabel=""
                ></pagination-controls>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="baseHealth.top_LoRaWAN != undefined">
            <div class="col">
              <div
                class="card m-2 align-items-center"
                style="width: max-content"
              >
                <div class="card-body">
                  <div class="ms-2" style="text-align: end">
                    <i
                      class="fa fa-copy"
                      style="cursor: pointer"
                      (click)="copyToClipboard(baseHealth.top_LoRaWAN)"
                      ngbTooltip="Copiar para área de transferência"
                      aria-hidden="true"
                    ></i>
                  </div>
                  <table class="table table-fit table-bordered table-hover">
                    <thead class="table-primary">
                      <tr>
                        <th class="text-center" scope="col" colspan="2">
                          Top pacotes LoRaWAN
                        </th>
                      </tr>
                      <tr>
                        <th class="text-center" scope="col">Serial</th>
                        <th class="text-center" scope="col">Qtd</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        *ngFor="
                          let item of baseHealth.top_LoRaWAN.seriais
                            | paginate
                              : {
                                  itemsPerPage: 5,
                                  currentPage:
                                    baseHealth.top_LoRaWAN.currentPage,
                                  id: 'top_LoRaWAN'
                                };
                          let i = index
                        "
                      >
                        <td class="text-center" scope="row">{{ item }}</td>
                        <td class="" scope="row">
                          {{
                            baseHealth.top_LoRaWAN.qtd[
                              getIndex(baseHealth.top_LoRaWAN.seriais, item)
                            ]
                          }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <pagination-controls
                  [autoHide]="true"
                  [maxSize]="5"
                  id="top_LoRaWAN"
                  (pageChange)="baseHealth.top_LoRaWAN.currentPage = $event"
                  nextLabel=""
                  previousLabel=""
                ></pagination-controls>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="baseHealth.top_LoRa_P2P != undefined">
            <div class="col">
              <div
                class="card m-2 align-items-center"
                style="width: max-content"
              >
                <div class="card-body">
                  <div class="ms-2" style="text-align: end">
                    <i
                      class="fa fa-copy"
                      style="cursor: pointer"
                      (click)="copyToClipboard(baseHealth.top_LoRa_P2P)"
                      ngbTooltip="Copiar para área de transferência"
                      aria-hidden="true"
                    ></i>
                  </div>
                  <table class="table table-fit table-bordered table-hover">
                    <thead class="table-primary">
                      <tr>
                        <th class="text-center" scope="col" colspan="2">
                          Top pacotes LoRa P2P
                        </th>
                      </tr>
                      <tr>
                        <th class="text-center" scope="col">Serial</th>
                        <th class="text-center" scope="col">Qtd</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        *ngFor="
                          let item of baseHealth.top_LoRa_P2P.seriais
                            | paginate
                              : {
                                  itemsPerPage: 5,
                                  currentPage:
                                    baseHealth.top_LoRa_P2P.currentPage,
                                  id: 'top_LoRa_P2P'
                                };
                          let i = index
                        "
                      >
                        <td class="text-center" scope="row">{{ item }}</td>
                        <td class="" scope="row">
                          {{
                            baseHealth.top_LoRa_P2P.qtd[
                              getIndex(baseHealth.top_LoRa_P2P.seriais, item)
                            ]
                          }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <pagination-controls
                  [autoHide]="true"
                  [maxSize]="5"
                  id="top_LoRa_P2P"
                  (pageChange)="baseHealth.top_LoRa_P2P.currentPage = $event"
                  nextLabel=""
                  previousLabel=""
                ></pagination-controls>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="baseHealth.top_GSM != undefined">
            <div class="col">
              <div class="card m-2" style="width: max-content">
                <div class="card-body">
                  <div class="ms-2" style="text-align: end">
                    <i
                      class="fa fa-copy"
                      style="cursor: pointer"
                      (click)="copyToClipboard(baseHealth.top_GSM)"
                      ngbTooltip="Copiar para área de transferência"
                      aria-hidden="true"
                    ></i>
                  </div>
                  <table class="table table-fit table-bordered table-hover">
                    <thead class="table-primary">
                      <tr>
                        <th class="text-center" scope="col" colspan="2">
                          Top pacotes GSM
                        </th>
                      </tr>
                      <tr>
                        <th class="text-center" scope="col">Serial</th>
                        <th class="text-center" scope="col">Qtd</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        *ngFor="
                          let item of baseHealth.top_GSM.seriais
                            | paginate
                              : {
                                  itemsPerPage: 5,
                                  currentPage: baseHealth.top_GSM.currentPage,
                                  id: 'top_GSM'
                                };
                          let i = index
                        "
                      >
                        <td class="text-center" scope="row">{{ item }}</td>
                        <td class="" scope="row">
                          {{
                            baseHealth.top_GSM.qtd[
                              getIndex(baseHealth.top_GSM.seriais, item)
                            ]
                          }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <pagination-controls
                  [autoHide]="true"
                  [maxSize]="5"
                  id="top_GSM"
                  (pageChange)="baseHealth.top_GSM.currentPage = $event"
                  nextLabel=""
                  previousLabel=""
                ></pagination-controls>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="baseHealth.class_name != undefined">
            <div class="col">
              <div class="card m-2" style="width: max-content">
                <div class="card-body">
                  <div class="ms-2" style="text-align: end">
                    <i
                      class="fa fa-copy"
                      style="cursor: pointer"
                      (click)="copyToClipboard(baseHealth.class_name)"
                      ngbTooltip="Copiar para área de transferência"
                      aria-hidden="true"
                    ></i>
                  </div>
                  <table class="table table-fit table-bordered table-hover">
                    <thead class="table-primary">
                      <tr>
                        <th class="text-center" scope="col" colspan="2">
                          Classes
                        </th>
                      </tr>
                      <tr>
                        <th class="text-center" scope="col">Classe</th>
                        <th class="text-center" scope="col">Qtd</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        *ngFor="
                          let item of baseHealth.class_name.className
                            | paginate
                              : {
                                  itemsPerPage: 5,
                                  currentPage:
                                    baseHealth.class_name.currentPage,
                                  id: 'class_name'
                                };
                          let i = index
                        "
                      >
                        <td class="text-center" scope="row">{{ item }}</td>
                        <td class="" scope="row">
                          {{
                            baseHealth.class_name.qtd[
                              getIndex(baseHealth.class_name.className, item)
                            ]
                          }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <pagination-controls
                  [autoHide]="true"
                  [maxSize]="5"
                  id="class_name"
                  (pageChange)="baseHealth.class_name.currentPage = $event"
                  nextLabel=""
                  previousLabel=""
                ></pagination-controls>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="baseHealth.product_name != undefined">
            <div class="col">
              <div class="card m-2" style="width: max-content">
                <div class="card-body">
                  <div class="ms-2" style="text-align: end">
                    <i
                      class="fa fa-copy"
                      style="cursor: pointer"
                      (click)="copyToClipboard(baseHealth.product_name)"
                      ngbTooltip="Copiar para área de transferência"
                      aria-hidden="true"
                    ></i>
                  </div>
                  <table class="table table-fit table-bordered table-hover">
                    <thead class="table-primary">
                      <tr>
                        <th class="text-center" scope="col" colspan="2">
                          Produtos
                        </th>
                      </tr>
                      <tr>
                        <th class="text-center" scope="col">Produto</th>
                        <th class="text-center" scope="col">Qtd</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        *ngFor="
                          let item of baseHealth.product_name.productName
                            | paginate
                              : {
                                  itemsPerPage: 5,
                                  currentPage:
                                    baseHealth.product_name.currentPage,
                                  id: 'product_name'
                                };
                          let i = index
                        "
                      >
                        <td class="text-center" scope="row">{{ item }}</td>
                        <td class="" scope="row">
                          {{
                            baseHealth.product_name.qtd[
                              getIndex(
                                baseHealth.product_name.productName,
                                item
                              )
                            ]
                          }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <pagination-controls
                  [autoHide]="true"
                  [maxSize]="5"
                  id="product_name"
                  (pageChange)="baseHealth.product_name.currentPage = $event"
                  nextLabel=""
                  previousLabel=""
                ></pagination-controls>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="baseHealth.firmware != undefined">
            <div class="col">
              <div
                class="card m-2 align-items-center"
                style="width: max-content"
              >
                <div class="card-body">
                  <div class="ms-2" style="text-align: end">
                    <i
                      class="fa fa-copy"
                      style="cursor: pointer"
                      (click)="copyToClipboard(baseHealth.firmware)"
                      ngbTooltip="Copiar para área de transferência"
                      aria-hidden="true"
                    ></i>
                  </div>
                  <table class="table table-fit table-bordered table-hover">
                    <thead class="table-primary">
                      <tr>
                        <th class="text-center" scope="col" colspan="3">
                          Dispositivo Modelo x FW
                        </th>
                      </tr>
                      <tr>
                        <th class="text-center" scope="col">Model</th>
                        <th class="text-center" scope="col">Firmware</th>
                        <th class="text-center" scope="col">Qtd</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        *ngFor="
                          let id of baseHealth.firmware.id
                            | paginate
                              : {
                                  itemsPerPage: 15,
                                  currentPage: baseHealth.firmware.currentPage,
                                  id: 'deviceNameFW'
                                };
                          let i = index
                        "
                      >
                        <td class="" scope="row">
                          {{
                            baseHealth.firmware.deviceName[
                              getIndex(baseHealth.firmware.id, id)
                            ]
                          }}
                        </td>
                        <td class="" scope="row">
                          {{
                            baseHealth.firmware.firmware[
                              getIndex(baseHealth.firmware.id, id)
                            ]
                          }}
                        </td>
                        <td class="" scope="row">
                          {{
                            baseHealth.firmware.qtd[
                              getIndex(baseHealth.firmware.id, id)
                            ]
                          }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <pagination-controls
                  [autoHide]="true"
                  [maxSize]="5"
                  id="deviceNameFW"
                  (pageChange)="baseHealth.firmware.currentPage = $event"
                  nextLabel=""
                  previousLabel=""
                ></pagination-controls>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="baseHealth.integration != undefined">
            <div class="col">
              <div
                class="card m-2 align-items-center"
                style="width: max-content"
              >
                <div class="card-body">
                  <div class="ms-2" style="text-align: end">
                    <i
                      class="fa fa-copy"
                      style="cursor: pointer"
                      (click)="copyToClipboard(baseHealth.integration)"
                      ngbTooltip="Copiar para área de transferência"
                      aria-hidden="true"
                    ></i>
                  </div>
                  <table class="table table-fit table-bordered table-hover">
                    <thead class="table-primary">
                      <tr>
                        <th class="text-center" scope="col" colspan="2">
                          Integrações
                        </th>
                      </tr>
                      <tr>
                        <th class="text-center" scope="col">Empresa</th>
                        <th class="text-center" scope="col">Qtd</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        *ngFor="
                          let item of baseHealth.integration.integration
                            | paginate
                              : {
                                  itemsPerPage: 10,
                                  currentPage:
                                    baseHealth.integration.currentPage,
                                  id: 'integration'
                                };
                          let i = index
                        "
                      >
                        <td class="text-center" scope="row">{{ item }}</td>
                        <td class="" scope="row">
                          {{
                            baseHealth.integration.qtd[
                              getIndex(baseHealth.integration.integration, item)
                            ]
                          }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <pagination-controls
                  [autoHide]="true"
                  [maxSize]="5"
                  id="integration"
                  (pageChange)="baseHealth.integration.currentPage = $event"
                  nextLabel=""
                  previousLabel=""
                ></pagination-controls>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="baseHealth.status_vetor != undefined">
            <div class="col">
              <div
                class="card m-2 align-items-center"
                style="width: max-content"
              >
                <div class="card-body">
                  <div class="ms-2" style="text-align: end">
                    <i
                      class="fa fa-copy"
                      style="cursor: pointer"
                      (click)="copyToClipboard(baseHealth.status_vetor)"
                      ngbTooltip="Copiar para área de transferência"
                      aria-hidden="true"
                    ></i>
                  </div>
                  <table class="table table-fit table-bordered table-hover">
                    <thead class="table-primary">
                      <tr>
                        <th class="text-center" scope="col" colspan="2">
                          Status Vetor
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        *ngFor="
                          let item of baseHealth.status_vetor.statusVetor
                            | paginate
                              : {
                                  itemsPerPage: 10,
                                  currentPage:
                                    baseHealth.status_vetor.currentPage,
                                  id: 'status_vetor'
                                };
                          let i = index
                        "
                      >
                        <td class="text-center" scope="row">{{ item }}</td>
                        <td class="" scope="row">
                          {{
                            baseHealth.status_vetor.qtd[
                              getIndex(
                                baseHealth.status_vetor.statusVetor,
                                item
                              )
                            ]
                          }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <pagination-controls
                  [autoHide]="true"
                  [maxSize]="5"
                  id="status_vetor"
                  (pageChange)="baseHealth.status_vetor.currentPage = $event"
                  nextLabel=""
                  previousLabel=""
                ></pagination-controls>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="baseMEGAHealth.contracts != undefined">
            <div class="col">
              <div
                class="card m-2 align-items-center"
                style="width: max-content"
              >
                <div class="card-body">
                  <div class="ms-2" style="text-align: end">
                    <i
                      class="fa fa-copy"
                      style="cursor: pointer"
                      (click)="copyToClipboard(baseMEGAHealth.contracts)"
                      ngbTooltip="Copiar para área de transferência"
                      aria-hidden="true"
                    ></i>
                  </div>
                  <table class="table table-fit table-bordered table-hover">
                    <thead class="table-primary">
                      <tr>
                        <th class="text-center" scope="col" colspan="2">
                          Contratos
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        *ngFor="
                          let item of baseMEGAHealth.contracts.contracts
                            | paginate
                              : {
                                  itemsPerPage: 10,
                                  currentPage:
                                    baseMEGAHealth.contracts.currentPage,
                                  id: 'contracts'
                                };
                          let i = index
                        "
                      >
                        <td class="text-center" scope="row">{{ item }}</td>
                        <td class="" scope="row">
                          {{
                            baseMEGAHealth.contracts.qtd[
                              getIndex(baseMEGAHealth.contracts.contracts, item)
                            ]
                          }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <pagination-controls
                  [autoHide]="true"
                  [maxSize]="10"
                  id="contracts"
                  (pageChange)="baseMEGAHealth.contracts.currentPage = $event"
                  nextLabel=""
                  previousLabel=""
                ></pagination-controls>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="baseHealth.top_Events != undefined">
            <div class="col">
              <div class="card m-2 align-items-center" style="overflow: auto">
                <div class="card-body" style="width: -webkit-fill-available">
                  <table class="table table-fit table-bordered table-hover">
                    <thead class="table-primary">
                      <tr>
                        <th
                          *ngFor="
                            let item of getKeys(baseHealth.top_Events);
                            let i = index
                          "
                          class="text-center"
                          scope="col"
                        >
                          {{ item }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <ng-container
                        *ngFor="
                          let subItem of transpose(baseHealth.top_Events);
                          let i = index
                        "
                      >
                        <tr>
                          <td
                            class="text-center"
                            scope="row"
                            *ngFor="
                              let item of getKeys(baseHealth.top_Events);
                              let i = index
                            "
                          >
                            {{ subItem[i].serial }} - {{ subItem[i].qtd }}
                          </td>
                        </tr>
                      </ng-container>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </ng-container>
    </div>
  </ng-template>

  <!-- Tab Mega-->
  <ng-template #TabMEGA>
    <div
      class="card mt-2 align-items-center"
      style="background-color: lightgray"
    >
      <ng-container *ngIf="baseMEGAHealth != undefined">
        <div class="row d-flex justify-content-between">
          <div class="card d-flex" style="align-items: center">
            <h3 class="text-align-center">
              {{ baseMEGAHealth.date }} - MEGA
              <i
                class="fa fa-info-circle"
                aria-hidden="true"
                ngbTooltip="Informação do MEGA, para acompanhar alguns problemas o quanto antes relacionado a status de dispositivos e linhas"
              ></i>
            </h3>
          </div>
          <div class="row d-flex">
            <div class="col">
              <div class="card m-2 align-items-center">
                <div class="card-body">
                  <table class="table table-fit table-bordered table-hover">
                    <thead class="table-primary">
                      <tr>
                        <th class="text-center" scope="col" colspan="3">
                          <div class="d-inline">
                            Dispositivo Instalado Linhas
                            <button
                              class="btn btn-sm btn-primary"
                              (click)="
                                openInfoSQL(
                                  sqlTemplate,
                                  baseMEGAHealth.deviceInstalledProblemLine.sql
                                )
                              "
                            >
                              sql
                            </button>
                          </div>
                        </th>
                      </tr>
                      <tr>
                        <th class="text-center" scope="col">Seriais</th>
                        <th class="text-center" scope="col">
                          Linha <br />Status
                        </th>
                        <th class="text-center" scope="col">
                          Linha <br />Serv. Status
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        *ngFor="
                          let item of baseMEGAHealth.deviceInstalledProblemLine
                            .seriais
                            | paginate
                              : {
                                  itemsPerPage: 5,
                                  currentPage:
                                    baseMEGAHealth.deviceInstalledProblemLine
                                      .currentPage,
                                  id: 'deviceInstalledProblemLine'
                                };
                          let i = index
                        "
                      >
                        <td class="text-center" scope="row">{{ item }}</td>
                        <td class="" scope="row">
                          {{
                            baseMEGAHealth.deviceInstalledProblemLine
                              .lineStatus[
                              getIndex(
                                baseMEGAHealth.deviceInstalledProblemLine
                                  .seriais,
                                item
                              )
                            ] == -1
                              ? "Sem linha"
                              : baseMEGAHealth.deviceInstalledProblemLine
                                  .lineStatus[
                                  getIndex(
                                    baseMEGAHealth.deviceInstalledProblemLine
                                      .seriais,
                                    item
                                  )
                                ]
                          }}
                        </td>
                        <td class="" scope="row">
                          {{
                            baseMEGAHealth.deviceInstalledProblemLine
                              .lineStatusService[
                              getIndex(
                                baseMEGAHealth.deviceInstalledProblemLine
                                  .seriais,
                                item
                              )
                            ] == -1
                              ? "Sem linha"
                              : baseMEGAHealth.deviceInstalledProblemLine
                                  .lineStatusService[
                                  getIndex(
                                    baseMEGAHealth.deviceInstalledProblemLine
                                      .seriais,
                                    item
                                  )
                                ]
                          }}
                        </td>
                      </tr>
                      <ng-container
                        *ngIf="
                          baseMEGAHealth.deviceInstalledProblemLine.seriais
                            .length == 0
                        "
                      >
                        <tr>
                          <td class="text-center" colspan="3" scope="row">
                            Sem problemas
                          </td>
                        </tr>
                      </ng-container>
                    </tbody>
                  </table>
                </div>
                <pagination-controls
                  [autoHide]="true"
                  [maxSize]="5"
                  id="deviceInstalledProblemLine"
                  (pageChange)="
                    baseMEGAHealth.deviceInstalledProblemLine.currentPage =
                      $event
                  "
                  nextLabel=""
                  previousLabel=""
                ></pagination-controls>
              </div>
            </div>
            <div class="col">
              <div class="card m-2 align-items-center">
                <div class="card-body">
                  <table class="table table-fit table-bordered table-hover">
                    <thead class="table-primary">
                      <tr>
                        <th class="text-center" scope="col" colspan="2">
                          <div class="d-inline">
                            Dispositivo com problema de Status
                            <button
                              class="btn btn-sm btn-primary"
                              (click)="
                                openInfoSQL(
                                  sqlTemplate,
                                  baseMEGAHealth.deviceStatus.sql
                                )
                              "
                            >
                              sql
                            </button>
                          </div>
                        </th>
                      </tr>
                      <tr>
                        <th class="text-center" scope="col">Seriais</th>
                        <th class="text-center" scope="col">
                          Status <br />do dispositivo
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        *ngFor="
                          let item of baseMEGAHealth.deviceStatus.seriais
                            | paginate
                              : {
                                  itemsPerPage: 5,
                                  currentPage:
                                    baseMEGAHealth.deviceStatus.currentPage,
                                  id: 'deviceStatus'
                                };
                          let i = index
                        "
                      >
                        <td class="text-center" scope="row">{{ item }}</td>
                        <td class="" scope="row">
                          {{
                            baseMEGAHealth.deviceStatus.deviceStatus[
                              getIndex(
                                baseMEGAHealth.deviceStatus.seriais,
                                item
                              )
                            ]
                          }}
                        </td>
                      </tr>
                      <ng-container
                        *ngIf="baseMEGAHealth.deviceStatus.seriais.length == 0"
                      >
                        <tr>
                          <td class="text-center" colspan="2" scope="row">
                            Sem problemas
                          </td>
                        </tr>
                      </ng-container>
                    </tbody>
                  </table>
                </div>
                <pagination-controls
                  [autoHide]="true"
                  [maxSize]="5"
                  id="deviceStatus"
                  (pageChange)="
                    baseMEGAHealth.deviceStatus.currentPage = $event
                  "
                  nextLabel=""
                  previousLabel=""
                ></pagination-controls>
              </div>
            </div>
            <div class="col">
              <div class="card m-2 align-items-center">
                <div class="ms-2" style="text-align: end">
                  <i
                    class="fa fa-copy"
                    style="cursor: pointer"
                    (click)="
                      copyToClipboard(baseMEGAHealth.deviceProblemShipment)
                    "
                    ngbTooltip="Copiar para área de transferência"
                    aria-hidden="true"
                  ></i>
                </div>
                <div class="card-body">
                  <table class="table table-fit table-bordered table-hover">
                    <thead class="table-primary">
                      <tr>
                        <th class="text-center" scope="col" colspan="4">
                          <div class="d-inline">
                            Dispositivo Remessa
                            <button
                              class="btn btn-sm btn-primary"
                              (click)="
                                openInfoSQL(
                                  sqlTemplate,
                                  baseMEGAHealth.deviceProblemShipment.sql
                                )
                              "
                            >
                              sql
                            </button>
                          </div>
                        </th>
                      </tr>
                      <tr>
                        <th class="text-center" scope="col">Seriais</th>
                        <th class="text-center" scope="col">
                          Identificador<br />remessa
                        </th>
                        <th class="text-center" scope="col">
                          Problema<br />Dispositivo<br />Status
                        </th>
                        <th class="text-center" scope="col">
                          Problema<br />linha
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        *ngFor="
                          let item of baseMEGAHealth.deviceProblemShipment
                            .seriais
                            | paginate
                              : {
                                  itemsPerPage: 5,
                                  currentPage:
                                    baseMEGAHealth.deviceProblemShipment
                                      .currentPage,
                                  id: 'deviceProblemShipment'
                                };
                          let i = index
                        "
                      >
                        <td class="text-center" scope="row">{{ item }}</td>
                        <td class="" scope="row">
                          {{
                            baseMEGAHealth.deviceProblemShipment
                              .shipmentIdentifier[
                              getIndex(
                                baseMEGAHealth.deviceProblemShipment.seriais,
                                item
                              )
                            ]
                          }}
                        </td>
                        <td class="" scope="row">
                          {{
                            baseMEGAHealth.deviceProblemShipment
                              .isProblemDeviceStatus[
                              getIndex(
                                baseMEGAHealth.deviceProblemShipment.seriais,
                                item
                              )
                            ]
                          }}
                        </td>
                        <td class="" scope="row">
                          {{
                            baseMEGAHealth.deviceProblemShipment.isProblemLine[
                              getIndex(
                                baseMEGAHealth.deviceProblemShipment.seriais,
                                item
                              )
                            ]
                          }}
                        </td>
                      </tr>
                      <ng-container
                        *ngIf="
                          baseMEGAHealth.deviceProblemShipment
                            .shipmentIdentifier.length == 0
                        "
                      >
                        <tr>
                          <td class="text-center" colspan="4" scope="row">
                            Sem problemas
                          </td>
                        </tr>
                      </ng-container>
                    </tbody>
                  </table>
                </div>
                <pagination-controls
                  [autoHide]="true"
                  [maxSize]="5"
                  id="deviceProblemShipment"
                  (pageChange)="
                    baseMEGAHealth.deviceProblemShipment.currentPage = $event
                  "
                  nextLabel=""
                  previousLabel=""
                ></pagination-controls>
              </div>
            </div>
            <div class="col">
              <div class="card-body">
                <ngb-accordion #acc="ngbAccordion">
                  <ngb-panel id="static-class-model">
                    <ng-template ngbPanelTitle class="accordion-header">
                      <h2
                        class="accordion-header"
                        id="gen-ques-heading_class_model"
                      >
                        <button
                          class="accordion-button"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#gen-ques-collapse_class_model"
                          aria-expanded="false"
                          aria-controls="gen-ques-collapse_class_model"
                        >
                          Classe e Modelos compatíveis cadastrados
                        </button>
                      </h2>
                    </ng-template>
                    <ng-template ngbPanelContent>
                      <div class="card m-2 align-items-center">
                        <div class="ms-2" style="text-align: end">
                          <i
                            class="fa fa-copy"
                            style="cursor: pointer"
                            (click)="
                              copyToClipboard(baseMEGAHealth.classDevice)
                            "
                            ngbTooltip="Copiar para área de transferência"
                            aria-hidden="true"
                          ></i>
                        </div>

                        <ng-select
                          class="custom"
                          id="productSelect"
                          placeholder="Selecione um produto"
                          [ngModelOptions]="{ standalone: true }"
                          [(ngModel)]="productSelect"
                          [searchable]="true"
                          [multiple]="true"
                          (change)="getProductFilter(productSelect)"
                          [markFirst]="true"
                        >
                          <ng-option
                            *ngFor="let product of productsSelectAux"
                            [value]="product"
                          >
                            <div>
                              {{ product }}
                            </div>
                          </ng-option>
                        </ng-select>
                        <table
                          class="table table-fit table-bordered table-hover"
                        >
                          <thead class="table-primary">
                            <tr>
                              <th class="text-center" scope="col" colspan="5">
                                <div class="d-inline">
                                  Classe e Modelos compatíveis cadastrados
                                  <button
                                    class="btn btn-sm btn-primary"
                                    (click)="
                                      openInfoSQL(
                                        sqlTemplate,
                                        baseMEGAHealth.classDevice.sql +
                                          '\n' +
                                          baseMEGAHealth.classAccessory.sql
                                      )
                                    "
                                  >
                                    sql
                                  </button>
                                </div>
                              </th>
                            </tr>
                            <tr>
                              <th class="text-center" scope="col">Classe</th>
                              <th class="text-center" scope="col">
                                Caracteristica
                              </th>
                              <th class="text-center" scope="col">
                                Dispositivos
                              </th>
                              <th class="text-center" scope="col">
                                Acessórios
                              </th>
                              <th class="text-center" scope="col">
                                Produtos usando a classe
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              *ngFor="
                                let item of products.class
                                  | paginate
                                    : {
                                        itemsPerPage: 15,
                                        currentPage: products.currentPage,
                                        id: 'classDevice'
                                      };
                                let i = index
                              "
                            >
                              <td class="text-center" scope="row">
                                {{ item.split("|")[0] }}
                                <ng-container *ngIf="item.split('|')[1] != ''">
                                  <div
                                    class="badge"
                                    [ngClass]="{
                                      'bg-success':
                                        item.split('|')[1] == 'Ativo',
                                      'bg-secondary':
                                        item.split('|')[1] != 'Ativo'
                                    }"
                                  >
                                    <b>{{ item.split("|")[1] }}</b>
                                  </div>
                                </ng-container>
                              </td>
                              <td class="" scope="row">
                                <ng-container
                                  *ngIf="
                                    baseMEGAHealth.classDevice.attributes[
                                      getIndex(
                                        baseMEGAHealth.classDevice.class,
                                        item
                                      )
                                    ] != ''
                                  "
                                >
                                  {{
                                    baseMEGAHealth.classDevice.attributes[
                                      getIndex(
                                        baseMEGAHealth.classDevice.class,
                                        item
                                      )
                                    ]
                                  }}
                                </ng-container>
                                <ng-container
                                  *ngIf="
                                    baseMEGAHealth.classDevice.attributes[
                                      getIndex(
                                        baseMEGAHealth.classDevice.class,
                                        item
                                      )
                                    ] == ''
                                  "
                                >
                                  {{
                                    baseMEGAHealth.classAccessory.attributes[
                                      getIndex(
                                        baseMEGAHealth.classAccessory.class,
                                        item
                                      )
                                    ]
                                  }}
                                </ng-container>
                              </td>
                              <td class="" scope="row">
                                <div
                                  *ngFor="
                                    let device of split(
                                      baseMEGAHealth.classDevice.model[
                                        getIndex(
                                          baseMEGAHealth.classDevice.class,
                                          item
                                        )
                                      ]
                                    )
                                  "
                                >
                                  <tr>
                                    <td class="" scope="row">
                                      {{ device.split("|")[0] }}
                                      <ng-container
                                        *ngIf="device.split('|')[1] != ''"
                                      >
                                        <div
                                          class="badge"
                                          [ngClass]="{
                                            'bg-success':
                                              device.split('|')[1] ==
                                              'Homologado',
                                            'bg-secondary':
                                              device.split('|')[1] !=
                                              'Homologado'
                                          }"
                                        >
                                          <b>{{ device.split("|")[1] }}</b>
                                        </div>
                                      </ng-container>
                                    </td>
                                  </tr>
                                </div>
                              </td>
                              <td class="" scope="row">
                                <div
                                  *ngFor="
                                    let accessory of split(
                                      baseMEGAHealth.classAccessory.model[
                                        getIndex(
                                          baseMEGAHealth.classAccessory.class,
                                          item
                                        )
                                      ]
                                    )
                                  "
                                >
                                  <tr>
                                    <td class="" scope="row">
                                      {{ accessory.split("|")[0] }}
                                      <ng-container
                                        *ngIf="accessory.split('|')[1] != ''"
                                      >
                                        <div
                                          class="badge"
                                          [ngClass]="{
                                            'bg-success':
                                              accessory.split('|')[1] ==
                                              'Homologado',
                                            'bg-secondary':
                                              accessory.split('|')[1] !=
                                              'Homologado'
                                          }"
                                        >
                                          <b>{{ accessory.split("|")[1] }}</b>
                                        </div>
                                      </ng-container>
                                    </td>
                                  </tr>
                                </div>
                              </td>
                              <td class="" scope="row">
                                <div
                                  *ngFor="
                                    let product of split(
                                      baseMEGAHealth.classDevice.product[
                                        getIndex(
                                          baseMEGAHealth.classDevice.class,
                                          item
                                        )
                                      ]
                                    )
                                  "
                                >
                                  <tr>
                                    <td scope="row">
                                      {{ product.split("|")[0] }}
                                      <ng-container
                                        *ngIf="product.split('|')[1] != ''"
                                      >
                                        <div
                                          class="badge"
                                          [ngClass]="{
                                            'bg-success':
                                              product.split('|')[1] == 'Ativo',
                                            'bg-secondary':
                                              product.split('|')[1] != 'Ativo',
                                            'd-none':
                                              product.split('|')[1] == ''
                                          }"
                                        >
                                          <b>{{ product.split("|")[1] }}</b>
                                        </div>
                                      </ng-container>
                                    </td>
                                  </tr>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <pagination-controls
                        [autoHide]="true"
                        [maxSize]="10"
                        id="classDevice"
                        (pageChange)="products.currentPage = $event"
                        nextLabel=""
                        previousLabel=""
                      ></pagination-controls>
                    </ng-template>
                  </ngb-panel>
                </ngb-accordion>
              </div>
            </div>
          </div>
        </div>

        <ng-container *ngIf="baseMEGAHealth.osOpen">
          <div class="card d-inline text-center">
            <h3>
              OS's abertas ({{ baseMEGAHealth.oSOpenCountService.date }}) :
            </h3>

            <b>{{ baseMEGAHealth.osOpen.os.length }}</b>
            <i
              class="fa fa-info-circle ms-2"
              aria-hidden="true"
              ngbTooltip="roda uma vez por dia, de madrugada"
            ></i>
          </div>
          <div class="card m-2 align-items-center">
            <div class="ms-2" style="text-align: end">
              <i
                class="fa fa-copy"
                style="cursor: pointer"
                (click)="copyToClipboard(baseMEGAHealth.oSOpenCountService)"
                ngbTooltip="Copiar para área de transferência"
                aria-hidden="true"
              ></i>
            </div>
            <div class="card-body">
              <table class="table table-fit table-bordered table-hover">
                <thead class="table-primary">
                  <tr>
                    <th class="text-center" scope="col" colspan="2">
                      <div class="d-inline">
                        OS's abertas
                        <button
                          class="btn btn-sm btn-primary"
                          (click)="
                            openInfoSQL(
                              sqlTemplate,
                              baseMEGAHealth.oSOpenCountService.sql
                            )
                          "
                        >
                          sql
                        </button>
                      </div>
                    </th>
                  </tr>
                  <tr>
                    <th class="text-center" scope="col">OS Tipo</th>
                    <th class="text-center" scope="col">Qtd</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    *ngFor="
                      let item of baseMEGAHealth.oSOpenCountService.service
                        | paginate
                          : {
                              itemsPerPage: 10,
                              currentPage:
                                baseMEGAHealth.oSOpenCountService.currentPage,
                              id: 'oSOpenCountService'
                            };
                      let i = index
                    "
                  >
                    <td class="text-center" scope="row">{{ item }}</td>
                    <td class="" scope="row">
                      {{
                        baseMEGAHealth.oSOpenCountService.qtd[
                          getIndex(
                            baseMEGAHealth.oSOpenCountService.service,
                            item
                          )
                        ]
                      }}
                    </td>
                  </tr>
                  <tr>
                    <td>Total</td>
                    <td>{{ baseMEGAHealth.oSOpenCountService.total }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <pagination-controls
              [autoHide]="true"
              [maxSize]="10"
              id="oSOpenCountService"
              (pageChange)="
                baseMEGAHealth.oSOpenCountService.currentPage = $event
              "
              nextLabel=""
              previousLabel=""
            ></pagination-controls>
          </div>
          <div class="card m-2 align-items-center">
            <div class="ms-2" style="text-align: end">
              <i
                class="fa fa-copy"
                style="cursor: pointer"
                (click)="copyToClipboard(baseMEGAHealth.osOpen)"
                ngbTooltip="Copiar para área de transferência"
                aria-hidden="true"
              ></i>
            </div>
            <div class="card-body">
              <table class="table table-fit table-bordered table-hover">
                <thead class="table-primary">
                  <tr>
                    <th class="text-center" scope="col" colspan="6">
                      <div class="d-inline">
                        OS's abertas
                        <button
                          class="btn btn-sm btn-primary"
                          (click)="
                            openInfoSQL(sqlTemplate, baseMEGAHealth.osOpen.sql)
                          "
                        >
                          sql
                        </button>
                      </div>
                    </th>
                  </tr>
                  <tr>
                    <th class="text-center" scope="col">OS</th>
                    <th class="text-center" scope="col">Chassis</th>
                    <th class="text-center" scope="col">Contrato</th>
                    <th class="text-center" scope="col">Modelo</th>
                    <th class="text-center" scope="col">Produto</th>
                    <th class="text-center" scope="col">Serviço</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    *ngFor="
                      let item of baseMEGAHealth.osOpen.os
                        | paginate
                          : {
                              itemsPerPage: 5,
                              currentPage: baseMEGAHealth.osOpen.currentPage,
                              id: 'osOpen'
                            };
                      let i = index
                    "
                  >
                    <td class="text-center" scope="row">{{ item }}</td>
                    <td class="" scope="row">
                      {{
                        baseMEGAHealth.osOpen.chassis[
                          getIndex(baseMEGAHealth.osOpen.os, item)
                        ]
                      }}
                    </td>
                    <td class="" scope="row">
                      {{
                        baseMEGAHealth.osOpen.contract[
                          getIndex(baseMEGAHealth.osOpen.os, item)
                        ]
                      }}
                    </td>
                    <td class="" scope="row">
                      {{
                        baseMEGAHealth.osOpen.model[
                          getIndex(baseMEGAHealth.osOpen.os, item)
                        ]
                      }}
                    </td>

                    <td class="" scope="row">
                      {{
                        baseMEGAHealth.osOpen.product[
                          getIndex(baseMEGAHealth.osOpen.os, item)
                        ]
                      }}
                    </td>
                    <td class="" scope="row">
                      {{
                        baseMEGAHealth.osOpen.service[
                          getIndex(baseMEGAHealth.osOpen.os, item)
                        ]
                      }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <pagination-controls
              [autoHide]="true"
              [maxSize]="5"
              id="osOpen"
              (pageChange)="baseMEGAHealth.osOpen.currentPage = $event"
              nextLabel=""
              previousLabel=""
            ></pagination-controls>
          </div>

          <ng-container *ngIf="chartMEGA.length > 0">
            <canvas
              class="card m-2"
              baseChart
              [options]="chartMEGA[0].options"
              [plugins]="chartMEGA[0].plugins ?? []"
              [datasets]="chartMEGA[0].data.datasets"
              [labels]="chartMEGA[0].data.labels"
            >
            </canvas>
          </ng-container>
          <ng-container *ngIf="chartMEGA.length > 1">
            <canvas
              class="card m-2"
              baseChart
              [options]="chartMEGA[1].options"
              [plugins]="chartMEGA[1].plugins ?? []"
              [datasets]="chartMEGA[1].data.datasets"
              [labels]="chartMEGA[1].data.labels"
            >
            </canvas>
          </ng-container>
          <ng-container *ngIf="chartMEGA.length > 2">
            <canvas
              class="card m-2"
              baseChart
              [options]="chartMEGA[2].options"
              [plugins]="chartMEGA[2].plugins ?? []"
              [datasets]="chartMEGA[2].data.datasets"
              [labels]="chartMEGA[2].data.labels"
            >
            </canvas>
          </ng-container>
        </ng-container>
      </ng-container>
    </div>
  </ng-template>

  <!-- Tab Newsletter-->
  <ng-template #TabNewsletter>
    <div
      class="card mt-2 align-items-center"
      style="background-color: lightgray"
    >
      <ng-container *ngIf="newsletter != undefined">
        <div class="card m-2 align-items-center">
          <div class="card-body">
            <div class="d-inline">
              <input
                class="m-2"
                type="checkbox"
                [(ngModel)]="newsletterformat"
              />
              <ng-container *ngIf="newsletterformat">
                <label>Tabela</label>
              </ng-container>
              <ng-container *ngIf="!newsletterformat">
                <label>Grid</label>
              </ng-container>
            </div>
            <table class="table table-fit table-bordered table-hover">
              <thead class="table-primary">
                <tr>
                  <ng-container *ngIf="newsletterformat">
                    <th class="text-center" scope="col">
                      <div class="d-inline">Data</div>
                    </th>
                    <th class="text-center" scope="col">
                      <div class="d-inline">Titulo</div>
                    </th>
                    <th class="text-center" scope="col">
                      <div class="d-inline">Resumo</div>
                    </th>
                    <th class="text-center" scope="col">
                      <div class="d-inline">Link</div>
                    </th></ng-container
                  >
                  <ng-container *ngIf="!newsletterformat">
                    <th class="text-center" scope="col">
                      <div class="d-inline"></div>
                    </th>
                  </ng-container>
                </tr>
              </thead>
              <tbody>
                <tr
                  *ngFor="
                    let item of newsletter.title
                      | paginate
                        : {
                            itemsPerPage: newsletterformat ? 10 : 3,
                            currentPage: newsletter.currentPage,
                            id: 'newsletter'
                          };
                    let i = index
                  "
                >
                  <ng-container *ngIf="!newsletterformat">
                    <td>
                      <div class="card">
                        <div class="card-body">
                          <h5 class="card-title">
                            {{
                              newsletter?.title[
                                getIndex(newsletter.title, item)
                              ]
                            }}
                          </h5>
                          <p class="card-text">
                            {{
                              newsletter?.summary[
                                getIndex(newsletter.title, item)
                              ]
                            }}
                          </p>
                        </div>
                        <div class="card-footer">
                          <a
                            [href]="
                              newsletter?.url[getIndex(newsletter.title, item)]
                            "
                            target="_blank"
                            >{{
                              newsletter?.url[getIndex(newsletter.title, item)]
                            }}</a
                          >
                          <p class="card-author-date">
                            {{
                              newsletter?.source[
                                getIndex(newsletter.title, item)
                              ]
                            }}
                            -
                            {{
                              newsletter?.date[getIndex(newsletter.title, item)]
                            }}
                          </p>
                        </div>
                      </div>
                    </td>
                  </ng-container>
                  <ng-container *ngIf="newsletterformat">
                    <td>
                      {{ newsletter?.date[getIndex(newsletter.title, item)] }}
                      -

                      <b>{{
                        newsletter?.source[getIndex(newsletter.title, item)]
                      }}</b>
                    </td>

                    <td>
                      <b>{{
                        newsletter?.title[getIndex(newsletter.title, item)]
                      }}</b>
                    </td>
                    <td>
                      {{
                        newsletter?.summary[getIndex(newsletter.title, item)]
                      }}
                    </td>
                    <td>
                      <a
                        [href]="
                          newsletter?.url[getIndex(newsletter.title, item)]
                        "
                        target="_blank"
                      >
                        {{
                          newsletter?.url[getIndex(newsletter.title, item)]
                        }}</a
                      >
                    </td>
                  </ng-container>
                </tr>
              </tbody>
            </table>
          </div>
          <pagination-controls
            [autoHide]="true"
            [maxSize]="5"
            id="newsletter"
            (pageChange)="newsletter.currentPage = $event"
            nextLabel=""
            previousLabel=""
          ></pagination-controls>
        </div>
      </ng-container>
    </div>
  </ng-template>

  <!-- Tab A40B-->
  <ng-template #TabA40B>
    <div
      class="card mt-2 d-flex flex-wrap align-content-center"
      style="background-color: lightgray"
    >
      <ng-container *ngIf="baseHealthA40B != undefined">
        <div class="card" style="align-items: center">
          <h3 class="text-align-center">
            {{ baseHealthA40B.data }}
            {{ baseHealthA40B.total_devices_installed }} A40B instalados em
            {{ baseHealthA40B.total_vehicles_installed }} veículos
            <i
              class="fa fa-info-circle"
              aria-hidden="true"
              data-placement="bottom"
              ngbTooltip="Com base nas últimas posições do elastic"
            ></i>
          </h3>
        </div>
        <div class="card m-2">
          <div class="row d-flex" style="inline-size: -webkit-fill-available">
            <div class="w-50">
              <i
                class="fa fa-info-circle ms-5"
                aria-hidden="true"
                data-placement="left"
                ngbTooltip="Filtro considerando dispositivos que posicionaram nos últimos 3 dias"
              ></i>
              <canvas class baseChart [datasets]="data" [options]="config">
              </canvas>
            </div>
            <div class="w-50">
              <div>
                <label>Quantidade de dias</label>
                <input
                  type="number"
                  [(ngModel)]="chartLineGSMAmountItems[1]"
                  (change)="mounthGraphBaseHealthA40B()"
                />
              </div>
              <canvas
                baseChart
                [options]="chartA40BPosition.options"
                [datasets]="chartA40BPosition.data.datasets"
                [labels]="chartA40BPosition.data.labels"
              >
              </canvas>
            </div>
          </div>
        </div>
        <div class="row d-flex" style="inline-size: -webkit-fill-available">
          <div class="col">
            <div class="card m-2 align-items-center" style="width: max-content">
              <div class="card-body">
                <div style="text-align: end">
                  <i
                    class="fa fa-copy"
                    style="cursor: pointer"
                    (click)="
                      copyToClipboard(
                        baseHealthA40B.lastPositionWithoutPositionA40B
                      )
                    "
                    ngbTooltip="Copiar para área de transferência"
                    aria-hidden="true"
                  ></i>
                </div>
                <table class="table table-fit table-bordered table-hover">
                  <thead class="table-primary">
                    <tr>
                      <th class="text-center" scope="col" colspan="6">
                        A40B sem posição
                      </th>
                    </tr>
                    <tr>
                      <th class="text-center" scope="col">Serial</th>
                      <th class="text-center" scope="col">StatusVetor</th>
                      <th class="text-center" scope="col">
                        Dias<br />Instalados
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      *ngFor="
                        let item of baseHealthA40B
                          .lastPositionWithoutPositionA40B.seriais
                          | paginate
                            : {
                                itemsPerPage: 5,
                                currentPage:
                                  baseHealthA40B.lastPositionWithoutPositionA40B
                                    .currentPage,
                                id: 'lastPositionWithoutPositionA40B'
                              };
                        let i = index
                      "
                    >
                      <td class="text-center" scope="row">{{ item }}</td>
                      <td class="" scope="row">
                        {{
                          baseHealthA40B.lastPositionWithoutPositionA40B
                            .statusVetor[
                            getIndex(
                              baseHealthA40B.lastPositionWithoutPositionA40B
                                .seriais,
                              item
                            )
                          ]
                        }}
                      </td>
                      <td class="" scope="row">
                        {{
                          baseHealthA40B.lastPositionWithoutPositionA40B
                            .diasInstalado[
                            getIndex(
                              baseHealthA40B.lastPositionWithoutPositionA40B
                                .seriais,
                              item
                            )
                          ]
                        }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <pagination-controls
                [autoHide]="true"
                [maxSize]="5"
                id="lastPositionWithoutPositionA40B"
                (pageChange)="
                  baseHealthA40B.lastPositionWithoutPositionA40B.currentPage =
                    $event
                "
                nextLabel=""
                previousLabel=""
              ></pagination-controls>
            </div>
          </div>
          <div class="col-md-12" style="overflow: auto">
            <div class="card m-2 align-items-center" style="width: max-content">
              <div class="card-body" style="width: max-content">
                <div style="text-align: end">
                  <i
                    class="fa fa-copy"
                    style="cursor: pointer"
                    (click)="
                      copyToClipboard(
                        baseHealthA40B.lastPositionBatteryLowerA40B
                      )
                    "
                    ngbTooltip="Copiar para área de transferência"
                    aria-hidden="true"
                  ></i>
                </div>

                <table class="table table-fit table-bordered table-hover">
                  <thead class="table-primary">
                    <tr>
                      <th class="text-center" scope="col" colspan="8">
                        A40B ordenado pelo valor de bateria interna ascendente
                      </th>
                    </tr>
                    <tr>
                      <th class="text-center" scope="col">Serial</th>
                      <th class="text-center" scope="col">Bateria</th>
                      <th class="text-center" scope="col">Status<br />Vetor</th>
                      <th class="text-center" scope="col">
                        Dias<br />Instalados
                      </th>
                      <th class="text-center" scope="col">
                        Dias<br />Sem<br />Posição
                      </th>
                      <th class="text-center" scope="col">
                        Origem<br />Mensagem
                      </th>
                      <th class="text-center" scope="col">RevGeo</th>
                      <th class="text-center" scope="col">
                        Outro <br />device
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      *ngFor="
                        let item of baseHealthA40B.lastPositionBatteryLowerA40B
                          .seriais
                          | paginate
                            : {
                                itemsPerPage: 5,
                                currentPage:
                                  baseHealthA40B.lastPositionBatteryLowerA40B
                                    .currentPage,
                                id: 'lastPositionBatteryLowerA40B'
                              };
                        let i = index
                      "
                    >
                      <td class="text-center" scope="row">{{ item }}</td>
                      <td class="" scope="row">
                        {{
                          baseHealthA40B.lastPositionBatteryLowerA40B.battery[
                            getIndex(
                              baseHealthA40B.lastPositionBatteryLowerA40B
                                .seriais,
                              item
                            )
                          ]
                        }}
                      </td>
                      <td class="" scope="row">
                        {{
                          baseHealthA40B.lastPositionBatteryLowerA40B
                            .statusVetor[
                            getIndex(
                              baseHealthA40B.lastPositionBatteryLowerA40B
                                .seriais,
                              item
                            )
                          ]
                        }}
                      </td>
                      <td class="" scope="row">
                        {{
                          baseHealthA40B.lastPositionBatteryLowerA40B
                            .diasInstalado[
                            getIndex(
                              baseHealthA40B.lastPositionBatteryLowerA40B
                                .seriais,
                              item
                            )
                          ]
                        }}
                      </td>
                      <td class="" scope="row">
                        {{
                          baseHealthA40B.lastPositionBatteryLowerA40B
                            .diasSemPosicao[
                            getIndex(
                              baseHealthA40B.lastPositionBatteryLowerA40B
                                .seriais,
                              item
                            )
                          ]
                        }}
                      </td>
                      <td class="" scope="row">
                        {{
                          baseHealthA40B.lastPositionBatteryLowerA40B
                            .origem_mensagem[
                            getIndex(
                              baseHealthA40B.lastPositionBatteryLowerA40B
                                .seriais,
                              item
                            )
                          ]
                        }}
                      </td>
                      <td class="" scope="row">
                        {{
                          baseHealthA40B.lastPositionBatteryLowerA40B.revGeo[
                            getIndex(
                              baseHealthA40B.lastPositionBatteryLowerA40B
                                .seriais,
                              item
                            )
                          ]
                        }}
                      </td>
                      <td class="" scope="row">
                        {{
                          baseHealthA40B.lastPositionBatteryLowerA40B
                            .otherDevice[
                            getIndex(
                              baseHealthA40B.lastPositionBatteryLowerA40B
                                .seriais,
                              item
                            )
                          ]
                        }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <pagination-controls
                [autoHide]="true"
                [maxSize]="5"
                id="lastPositionBatteryLowerA40B"
                (pageChange)="
                  baseHealthA40B.lastPositionBatteryLowerA40B.currentPage =
                    $event
                "
                nextLabel=""
                previousLabel=""
              ></pagination-controls>
            </div>
          </div>

          <div class="col-md-12" style="overflow: auto">
            <div class="card m-2 align-items-center" style="width: max-content">
              <div class="card-body">
                <div style="text-align: end">
                  <i
                    class="fa fa-copy"
                    style="cursor: pointer"
                    (click)="
                      copyToClipboard(
                        baseHealthA40B.lastPositionOrberByDaysWithoutPositionA40B
                      )
                    "
                    ngbTooltip="Copiar para área de transferência"
                    aria-hidden="true"
                  ></i>
                </div>
                <table class="table table-fit table-bordered table-hover">
                  <thead class="table-primary">
                    <tr>
                      <th class="text-center" scope="col" colspan="8">
                        A40B ordernado por dias sem posições descendente
                      </th>
                    </tr>
                    <tr>
                      <th class="text-center" scope="col">Serial</th>
                      <th class="text-center" scope="col">Bateria</th>
                      <th class="text-center" scope="col">Status<br />Vetor</th>
                      <th class="text-center" scope="col">
                        Dias<br />Instalados
                      </th>
                      <th class="text-center" scope="col">
                        Dias<br />Sem<br />Posição
                      </th>
                      <th class="text-center" scope="col">
                        Origem<br />Mensagem
                      </th>
                      <th class="text-center" scope="col">RevGeo</th>
                      <th class="text-center" scope="col">
                        Outro <br />device
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      *ngFor="
                        let item of baseHealthA40B
                          .lastPositionOrberByDaysWithoutPositionA40B.seriais
                          | paginate
                            : {
                                itemsPerPage: 5,
                                currentPage:
                                  baseHealthA40B
                                    .lastPositionOrberByDaysWithoutPositionA40B
                                    .currentPage,
                                id: 'lastPositionOrberByDaysWithoutPositionA40B'
                              };
                        let i = index
                      "
                    >
                      <td class="text-center" scope="row">{{ item }}</td>
                      <td class="" scope="row">
                        {{
                          baseHealthA40B
                            .lastPositionOrberByDaysWithoutPositionA40B.battery[
                            getIndex(
                              baseHealthA40B
                                .lastPositionOrberByDaysWithoutPositionA40B
                                .seriais,
                              item
                            )
                          ]
                        }}
                      </td>
                      <td class="" scope="row">
                        {{
                          baseHealthA40B
                            .lastPositionOrberByDaysWithoutPositionA40B
                            .statusVetor[
                            getIndex(
                              baseHealthA40B
                                .lastPositionOrberByDaysWithoutPositionA40B
                                .seriais,
                              item
                            )
                          ]
                        }}
                      </td>
                      <td class="" scope="row">
                        {{
                          baseHealthA40B
                            .lastPositionOrberByDaysWithoutPositionA40B
                            .diasInstalado[
                            getIndex(
                              baseHealthA40B
                                .lastPositionOrberByDaysWithoutPositionA40B
                                .seriais,
                              item
                            )
                          ]
                        }}
                      </td>
                      <td class="" scope="row">
                        {{
                          baseHealthA40B
                            .lastPositionOrberByDaysWithoutPositionA40B
                            .diasSemPosicao[
                            getIndex(
                              baseHealthA40B
                                .lastPositionOrberByDaysWithoutPositionA40B
                                .seriais,
                              item
                            )
                          ]
                        }}
                      </td>
                      <td class="" scope="row">
                        {{
                          baseHealthA40B
                            .lastPositionOrberByDaysWithoutPositionA40B
                            .origem_mensagem[
                            getIndex(
                              baseHealthA40B
                                .lastPositionOrberByDaysWithoutPositionA40B
                                .seriais,
                              item
                            )
                          ]
                        }}
                      </td>
                      <td class="" scope="row">
                        {{
                          baseHealthA40B
                            .lastPositionOrberByDaysWithoutPositionA40B.revGeo[
                            getIndex(
                              baseHealthA40B
                                .lastPositionOrberByDaysWithoutPositionA40B
                                .seriais,
                              item
                            )
                          ]
                        }}
                      </td>
                      <td class="" scope="row">
                        {{
                          baseHealthA40B
                            .lastPositionOrberByDaysWithoutPositionA40B
                            .otherDevice[
                            getIndex(
                              baseHealthA40B
                                .lastPositionOrberByDaysWithoutPositionA40B
                                .seriais,
                              item
                            )
                          ]
                        }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <pagination-controls
                [autoHide]="true"
                [maxSize]="5"
                id="lastPositionOrberByDaysWithoutPositionA40B"
                (pageChange)="
                  baseHealthA40B.lastPositionOrberByDaysWithoutPositionA40B.currentPage =
                    $event
                "
                nextLabel=""
                previousLabel=""
              ></pagination-controls>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </ng-template>

  <!-- Tab InstallationPhotos-->
  <ng-template #TabInstallationPhotos>
    <div
      class="card mt-2 d-flex flex-wrap align-content-center"
      style="background-color: lightgray"
    >
      <ng-container *ngIf="baseMEGAHealth != undefined">
        <div class="card" style="align-items: center">
          <h3 class="text-align-center">
            <i
              class="fa fa-info-circle"
              aria-hidden="true"
              data-placement="bottom"
              ngbTooltip="Amostragem de fotos das instalações realizadas nos últimos 7 dias"
            ></i>
          </h3>
        </div>
        <div class="card m-2 align-items-center">
          <div class="card-body">
            <table class="table table-fit table-bordered table-hover">
              <thead class="table-primary">
                <tr>
                  <th class="text-center" scope="col" colspan="4">
                    <div class="d-inline">
                      <button
                        class="btn btn-sm btn-primary"
                        (click)="
                          openInfoSQL(
                            sqlTemplate,
                            baseMEGAHealth.installationPhoto.sql
                          )
                        "
                      >
                        sql
                      </button>
                    </div>
                  </th>
                </tr>
                <tr>
                  <th class="text-center" scope="col">OS</th>
                  <th class="text-center" scope="col">Fotos</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  *ngFor="
                    let item of baseMEGAHealth.installationPhoto.sequences
                      | paginate
                        : {
                            itemsPerPage: 10,
                            currentPage:
                              baseMEGAHealth.installationPhoto.currentPage,
                            id: 'installationPhoto'
                          };
                    let i = index
                  "
                >
                  <td class="text-center" scope="row">
                    <a
                      style="cursor: pointer"
                      (click)="
                        openMegaOS(
                          'https://mega.satrastreamento.com.br/field-services/work-order-management/edit/' +
                            item[0]?.workOrderSequenceId
                        )
                      "
                      href="#"
                    >
                      {{ item[0].sequenceOS }}
                    </a>
                    <br />
                    <a class="card">{{ item[0].modelObject }} </a>
                    <a class="card">{{ item[0].locationInstallation }} </a>
                    <a class="card">{{ item[0].closingDate }} </a>
                    <a class="card">{{ item[0].product }} </a>
                  </td>
                  <td class="" scope="row" class="d-flex ms-2">
                    <ng-container
                      *ngFor="
                        let itemSequence of baseMEGAHealth.installationPhoto
                          .sequences[
                          getIndex(
                            baseMEGAHealth.installationPhoto.sequences,
                            item
                          )
                        ]
                      "
                    >
                      <div class="align-content-center">
                        {{ itemSequence.deviceName }}
                        <i
                          class="fa fa-search-plus ms-2"
                          aria-hidden="true"
                          style="cursor: pointer"
                          (click)="
                            openModelImage(
                              modalImagePhoto,
                              'data:image/jpeg;base64,' + itemSequence.image
                            )
                          "
                        ></i>
                        <div class="img-container">
                          <img
                            [src]="
                              'data:image/jpeg;base64,' + itemSequence.image
                            "
                            [alt]="itemSequence.urlFile"
                            width="200"
                          />
                        </div>
                      </div>
                    </ng-container>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <pagination-controls
            [autoHide]="true"
            [maxSize]="10"
            id="installationPhoto"
            (pageChange)="baseMEGAHealth.installationPhoto.currentPage = $event"
            nextLabel=""
            previousLabel=""
          ></pagination-controls>
        </div>
      </ng-container>
    </div>
  </ng-template>

  <ng-template #sqlTemplate>
    <div class="m-3 overflow-auto" style="height: 500px">
      <span [innerText]="sqlCode"> </span>
    </div>
  </ng-template>

  <ng-template #modalImagePhoto>
    <div class="m-3 overflow-auto">
      <img [src]="installationPhotoImage" />
    </div>
  </ng-template>

  <!-- Manutencao-->
  <ng-template #TabManut>
    <div class="card align-items-center">
      <h4>Em manutenção!</h4>
      <div>
        <img
          src="../../../../assets/images/manutencao.png"
          height="200"
          width="250"
          alt="image"
        />
      </div>
    </div>
  </ng-template>
</div>
